import React from 'react';
import styles from './Button.module.css';

export interface ButtonProps {
    className?: string;
    name: string | JSX.Element;
    onClick: () => void;
    id?: string;
    disabled?: boolean;
}

export function Button(props: ButtonProps) {
    const { className, name, disabled, id, onClick } = props;
    return (
        <button
            disabled={disabled}
            auto-id={id}
            className={` ${className} ${styles.btn}`}
            onClick={() => onClick()}>
            {name}
        </button>
    );
}
